<script lang="ts">
  import { Flex, Text, Link } from "@getprovi/craft";

  import { setupMenus } from "@retailer/svelte/ProductLines/Navigation/helpers";
  import { EventTracking } from "@shared/services/event_tracking/events";

  import { SideMenuLinkEntity } from "@shared/services/event_tracking/entities";

  const { trackClick } = EventTracking;

  export let closeMenu: () => void;

  const menuItems = setupMenus()[0] || {};

  const handleClick = (label: string) => {
    trackClick("side_menu_link", [new SideMenuLinkEntity({ label })]);
    closeMenu();
  };
</script>

<Flex column class="tablet:hidden" gap="16">
  <Text semibold>Browse Categories</Text>
  <Flex wrap as="ul" class="gap-x-24 gap-y-10">
    {#each menuItems?.menus || [] as menu, i}
      <Link
        href={`/product_listing?type=${menu.header.product_type_id}`}
        size="sm"
        variant="secondary"
        on:click={() => {
          handleClick(menu.header.label);
        }}
      >
        {menu.header.label}
      </Link>
    {/each}
    <Link
      variant="secondary"
      size="sm"
      href="/distributors"
      on:click={() => {
        handleClick("Distributor Catalogs");
      }}>Distributor Catalogs</Link
    >
  </Flex>
</Flex>
